import { ResponseTime as ResponseTimeComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

const DigitalSignatureExposure = () => {
    const {
        digitalSignatureExposureData,
        isFetchingDigitalSignatureExposure,
        isErrorDigitalSignatureExposure,
    } = useSessionDetailsContext();

    if (isFetchingDigitalSignatureExposure) {
        return <ContentLoader height="23.5rem" />;
    }

    if (isErrorDigitalSignatureExposure && !isFetchingDigitalSignatureExposure) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="20.5rem"
                />
            </ComponentWrapper>
        );
    }

    return <ResponseTimeComponent data={digitalSignatureExposureData} />;
};

export default DigitalSignatureExposure;
